import type { User } from 'Utilities/user/@types';

import {
  type MentionMeEnrolPayload,
  type MentionMeEnrolResponse,
  MENTION_ME_LOCALE_CODE,
  MENTION_ME_PARTNER_CODE,
} from 'Services/mentionMe';

type BuildEnrolPayloadArgs = {
  situation: string;
  user: Partial<User>;
};

export const buildEnrolPayload = ({
  situation,
  user,
}: BuildEnrolPayloadArgs): MentionMeEnrolPayload => {
  const firstname = user.firstName || user.name?.split(' ')[0];
  const surname = user.lastName || user.name?.split(' ').slice(1).join(' ') || undefined;

  return {
    customer: {
      emailAddress: user.email ?? '',
      ...(firstname ? { firstname } : {}),
      ...(surname ? { surname } : {}),
      ...(user.id == null ? {} : { uniqueIdentifier: String(user.id) }),
    },
    request: {
      localeCode: MENTION_ME_LOCALE_CODE,
      partnerCode: MENTION_ME_PARTNER_CODE,
      situation,
    },
  };
};

export const getReferralLink = (response: MentionMeEnrolResponse): string | undefined => {
  const links = response.shareLinks ?? [];

  return links.find(({ type }) => type?.toUpperCase() === 'GENERIC')?.url
    ?? links.find(({ url }) => Boolean(url))?.url;
};
